import styled from 'styled-components'

import CBanner from '../../components/Banner'
import CStepper from '../../components/DeclarationStepper'
import breakpoints from '../../theme/breakpoints'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: max-content;
  background-color: ${({ theme }) => theme.colors.aliceBlue};
`

export const Banner = styled(CBanner)`
  margin-bottom: 4rem;
  ${breakpoints.up('tablet')} {
    margin-bottom: 6rem;
  }
`

export const Stepper = styled(CStepper)`
  justify-content: center;
`
